(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    const syncDrawerExpandButton = (expandButton, details) => {
    if (!expandButton || !details) return;
    expandButton.setAttribute('aria-expanded', details.hasAttribute('open'));
  };

  const initBindtDrawerExpand = () => {
    document.querySelectorAll('header-drawer:not([data-bindt-expand-init])').forEach((headerDrawer) => {
      headerDrawer.setAttribute('data-bindt-expand-init', '');

      headerDrawer.addEventListener(
        'click',
        (event) => {
          const expandButton = event.target.closest('[data-drawer-expand-trigger]');
          if (!expandButton || !headerDrawer.contains(expandButton)) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          const menuRow = expandButton.closest('.menu-drawer__menu-row');
          const details = menuRow?.querySelector('.menu-drawer__expand-details');
          const summary = details?.querySelector('summary');

          if (!summary) return;

          summary.click();
          setTimeout(() => syncDrawerExpandButton(expandButton, details), 150);
        },
        true
      );

      headerDrawer.addEventListener('click', (event) => {
        const closeButton = event.target.closest('.menu-drawer__close-button--nested');
        if (!closeButton || !headerDrawer.contains(closeButton)) return;

        const menuRow = closeButton.closest('.menu-drawer__menu-row');
        const expandButton = menuRow?.querySelector('[data-drawer-expand-trigger]');
        const details = menuRow?.querySelector('.menu-drawer__expand-details');
        syncDrawerExpandButton(expandButton, details);
      });
    });
  };

  initBindtDrawerExpand();
  document.addEventListener('shopify:section:load', initBindtDrawerExpand);
  } catch(e) { console.error(e); }
})();

})();
